import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';

export const useBalance = () => {
    const balance = useUserSelector(prop('balance'));

    return balance?.balances?.real_gaming_balance?.amount;
};
